/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetMarginLimitOrderQueryVariables = Types.Exact<{
	input: Types.MarginLimitOrderInput;
}>;

export type GetMarginLimitOrderQuery = {
	__typename?: "Query";
	marginLimitOrder?: {
		__typename?: "MarginLimitOrder";
		cancellationDate?: any | null;
		cancellationReason?: string | null;
		destinationTag: string;
		assetAmount: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
		createdAt: any;
		exitOrderType: Types.MarginLimitOrderExitOrderType;
		id: string;
		pid: string;
		repayingFundsInUnderlyingAsset: {
			precision: number;
			unit_symbol: string;
			unit_symbol_type: string;
			value: string;
		};
		status: Types.MarginLimitOrderStatus;
		targetPrice: { precision: number; unit_symbol: string; unit_symbol_type: string; value: string };
		tradeType: Types.MarginLimitOrderTradeType;
		targetPriceChangePercentage: { value: string; precision: number };
		asset:
			| {
					__typename?: "CommodityAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "CryptoAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "EquityComplexEtfAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "EquityEtcAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "EquityEtfAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "EquityRightAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "EquityStockAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "EtfAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "GenericAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "IndexAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "LeverageAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "MetalAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "SecurityTokenAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  }
			| {
					__typename?: "StockAsset";
					automatedOrderActive?: boolean | null;
					maintenanceEnabled?: boolean | null;
					minWithdrawal?: { value: string; precision: number } | null;
					minimumBuyAmount?: { value: string; precision: number } | null;
					minimumSellAmount?: { value: string; precision: number } | null;
					name: string;
					orderTypes?: Array<Types.AssetOrderType | null> | null;
					pid: string;
					price: { value: string; precision: number };
					priceChange: { value: string; percentage: number };
					available?: boolean | null;
					symbol: string;
					withdrawActive?: boolean | null;
					logos: Array<{
						__typename?: "Image";
						height: number;
						mimeType: string;
						url: string;
						width: number;
					}>;
			  };
		fiat: {
			__typename?: "Fiat";
			exchangeRate: string;
			id: string;
			name: string;
			pid: string;
			symbol: string;
			symbolCharacter: string;
			logos: Array<{ __typename?: "Image"; height: number; mimeType: string; url: string; width: number }>;
		};
		destination?:
			| {
					__typename?: "AssetWallet";
					availableBalance?: {
						precision: number;
						unit_symbol: string;
						unit_symbol_type: string;
						value: string;
					} | null;
					id: string;
					name: string;
					pid: string;
					reservedBalance?: {
						precision: number;
						unit_symbol: string;
						unit_symbol_type: string;
						value: string;
					} | null;
					totalBalance?: {
						precision: number;
						unit_symbol: string;
						unit_symbol_type: string;
						value: string;
					} | null;
			  }
			| {
					__typename?: "FiatWallet";
					availableBalance?: {
						precision: number;
						unit_symbol: string;
						unit_symbol_type: string;
						value: string;
					} | null;
					id: string;
					name: string;
					pid: string;
					reservedBalance?: {
						precision: number;
						unit_symbol: string;
						unit_symbol_type: string;
						value: string;
					} | null;
					totalBalance?: {
						precision: number;
						unit_symbol: string;
						unit_symbol_type: string;
						value: string;
					} | null;
			  }
			| null;
	} | null;
};

export const GetMarginLimitOrderDocument = gql`
	query GetMarginLimitOrder($input: MarginLimitOrderInput!) {
		marginLimitOrder(input: $input) {
			asset {
				automatedOrderActive
				maintenanceEnabled
				minWithdrawal
				minimumBuyAmount
				minimumSellAmount
				name
				orderTypes
				pid
				price
				priceChange
				available
				symbol
				withdrawActive
				logos {
					height
					mimeType
					url
					width
				}
			}
			cancellationDate
			cancellationReason
			fiat {
				exchangeRate
				id
				logos {
					height
					mimeType
					url
					width
				}
				name
				pid
				symbol
				symbolCharacter
			}
			destinationTag
			assetAmount
			createdAt
			destination {
				availableBalance
				id
				name
				pid
				reservedBalance
				totalBalance
			}
			exitOrderType
			id
			pid
			repayingFundsInUnderlyingAsset
			status
			targetPrice
			tradeType
			destinationTag
			targetPriceChangePercentage
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetMarginLimitOrderGQLService extends Apollo.Query<
	GetMarginLimitOrderQuery,
	GetMarginLimitOrderQueryVariables
> {
	document = GetMarginLimitOrderDocument;
	client = "bff";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
